import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  triggerDefaultViewChangeRequest,
  triggerPaytableViewChangeRequest
} from "../../../core/containers/Keypad/Common/Keypad.actions";
import { IState } from "../../redux";
import {
  IPaytableButtonProps,
  PaytableButton as PaytableButtonComponent,
  State
} from "./PaytableButton";

export const PaytableButton = () => {
  const dispatch = useDispatch();

  const view = useSelector((state: IState) => state.view);
  const paytableActive = view === "PAYTABLE";

  const displayMode = useSelector((state: IState) => state.displayMode);
  const paytableAvailable = displayMode === "DEFAULT";

  let state = State.DEFAULT;

  if (!paytableAvailable) {
    state = State.DISABLED;
  } else if (paytableActive) {
    state = State.ACTIVE;
  }

  const onClick = () => {
    if (state === State.DISABLED) {
      return null;
    } else if (state === State.ACTIVE) {
      return dispatch(triggerDefaultViewChangeRequest());
    }

    return dispatch(triggerPaytableViewChangeRequest());
  };

  const paytableButtonProps: IPaytableButtonProps = {
    state,
    onClick
  };

  return <PaytableButtonComponent {...paytableButtonProps} />;
};

export {
  PaytableButtonWrapperForKeypadMobile,
  PaytableButtonWrapperForHeaderMobile
} from "./PaytableButton";
